import React, { Suspense } from 'react'
import { useSelector } from 'react-redux'

import { BANNER_VARIANT } from 'constants/uiConfig'

const LazyBannerV1 = React.lazy(() => import('./BannerV1'))
const LazyBannerV2 = React.lazy(() => import('./BannerV2'))

const Banner = (props) => {
  const general = useSelector((s) => s.uiConfig?.general)
  const variant = general?.bannerVariant?.[props.pageType] ?? BANNER_VARIANT.V1

  return (
    <Suspense fallback={null}>
      {variant === BANNER_VARIANT.V2
        ? (
          <LazyBannerV2 {...props} />
          )
        : (
          <LazyBannerV1 {...props} />
          )}
    </Suspense>
  )
}

export default Banner
